
import Vue from "vue";
import Loader from "@/components/Multiloader.vue";
import RangeDiagramTableSwitch from "@/components/RangeDiagramTableSwitch.vue";

export default Vue.extend({
  name: "Zeitreihen",
  components: {
    Loader,
    RangeDiagramTableSwitch
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      stammDataView: {
        name: "messstellen_grundwasser_stammdaten",
        condition: "messstellennummer=number:" + this.id
      },
      messstellen_art: null,
      dates: [] as any,
      selectedParam: 0,
      paramValues: [] as any[],
      diagramData: {} as any,
      tableHeader: [
        {
          text: "Datum",
          key: "DATUM"
        },
        {
          text: "Parameter",
          key: "PARAM_NAME"
        },
        {
          text: "Bezeichnung",
          key: "DATUM"
        },
        {
          text: "Status",
          key: "STATUS_BEZ"
        },
        {
          text: "Wert",
          key: "WERT"
        },
        {
          text: "Einheit",
          key: "EINHEIT"
        }
      ]
    };
  },
  computed: {
    parameterView: function() {
      return {
        name: "messstellen_grundwasser_messwertequalitativ_parameterdaten",
        condition: [
          "messst_nr=number:" + this.id,
          "MESSST_ART=number:" + (this as any).messstellen_art
        ]
      };
    },
    messwerteView: function() {
      return {
        name: "messstellen_grundwasser_messwertequalitativ_messwerte_zeitreihe",
        condition: [
          "messst_nr=number:" + this.id,
          "MESSST_ART=number:" + (this as any).messstellen_art,
          "STOFF_NR=number:" + (this as any).selectedParam
        ]
      };
    }
  },
  watch: {
    selectedParam: function() {
      // this.diagramData ={} as any;
    }
  },
  methods: {
    loadedStammData(data: any) {
      this.messstellen_art = data[0].MESSSTELLENARTID;
    },
    loadParamData(data: any[]) {
      /** structrue 
       [{ EINHEIT: "mg/L"
          EINHEIT_NR: 50
          PARAM_NAME: "Magnesium"
          STOFFNR: 11013 }...] */
      if (data && Array.isArray(data)) {
        this.paramValues = data.map(param => ({
          text: param.PARAM_NAME + " (" + param.EINHEIT + ")",
          value: param.STOFFNR
        }));
        this.selectedParam = this.paramValues[0].value;
      }
    },
    loadMesswerteData(data: any) {
      // /* Messwert Structure: {
      // DATUM: "25.09.2003 13:45",
      // ANA_DATUM: "2003-09-25T11:45:00.000+00:00",
      // EINHEIT_NR: 5,
      // PARAM_NR: "11028 / 11",
      // PARAM_NAME: "Antimon",
      // WERT: 2,
      // EINHEIT: "µg/L",
      // MESSST_NR: 2536170200,
      // STOFF_NR: 11028,
      // MESSSTELLENBEZEICHNUNG: "2190 Gau-Algesheim, ",
      // STATUS_BEZ: "kleiner als",
      // STATUS_BEZ_KURZ: "<",
      // STATUS_NR: 1
      // }
      //  */

      // filter data only with WERT
      data = data.filter(messwert => messwert.WERT);
      // map data to format
      const list = data.map(messwert => {
        const element = {
          // default data
          xValue: Date.parse(messwert.ANA_DATUM),
          yValue: messwert.WERT,
          // specific data
          parameterStatus:
            !messwert.STATUS_BEZ || messwert.STATUS_BEZ == "normal"
              ? "-"
              : messwert.STATUS_BEZ
        };

        return Object.assign(messwert, element);
      });

      const einheitBez = data[0].EINHEIT;
      const parameterBez = data[0].PARAM_NAME;

      // create diagram object
      this.diagramData = {
        list,
        parameter: this.selectedParam + "" || "",
        parameterBezeichnung: parameterBez,
        xUnit: "",
        yUnit: einheitBez,
        legendText: "Messwerte Grundwasser"
      };
    }
  }
});
